export { default as warrantyChart } from './warrantyChart'; //报修统计饼图

export { default as complaintsChart } from './complaintsChart'; //近七天投诉统计

export { default as lackStatisticalChart } from './lackStatisticalChart'; //应收已收欠费统计

export { default as earlyWarningChart } from './earlyWarningChart'; //近七天合同到期预警数

export { default as workOrderFeedbackRate } from './workOrderFeedbackRate'; //工单好评率

export { default as workOrderStatisticalBar } from './workOrderStatisticalBar'; //工单统计条

export { default as sevenDaysLineChart } from './sevenDaysLineChart'; //7天统计折线图

export { default as feeLineChart } from './feeLineChart'; //收费统计

export { default as deviceGauge } from './deviceGauge.vue'; //设备仪表盘